import {customLog} from "./../../customLog.js";
import * as updateDataActions from "../actions/updateDataActions";
import * as dataTransformations from "./../../appDataTransformations";

const stdRevisions = {
		compositions:-1,
		users:-1,
		tags:-1,
		contexts:-1,
		playlists:-1,
		prefabAudio:-1,
	};

const stdData =
{
	compositions:[],
	userData:{},
	contexts:[],
	users:[],
	tags:[],
	lists:[],
	prefabAudio: {},
	revisions: stdRevisions,
}
export const updateDataReducer = (state=stdData, action) =>
{
	var newState;// = Object.assign({}, state);
	switch(action.type)
	{
		case updateDataActions.setCurrentUserData:
			newState = {...state, userData:action.payload};
			break;

		case updateDataActions.setAvailableContexts:
			newState = {...state, contexts:action.payload};
			break;

		case updateDataActions.setAvailableUsersData:
			newState = {...state, users: action.payload};
			break;

		case updateDataActions.setAvailableTags:
			newState = {...state, tags: action.payload};
			break;

		case updateDataActions.setAvailableCompositions:
			newState = {...state, compositions: action.payload};
			break;

		case updateDataActions.K_setAvailableLists:
			newState = {...state, lists: action.payload};
			break;

		case updateDataActions.K_setAvailablePrefabAudio:
			newState = {...state, prefabAudio: action.payload};
			break;

		case updateDataActions.k_setRevisions:
			const newRevisions = action.payload.merge ?
				{...state.revisions, ...action.payload.revisions} :
				action.payload.revisions;

			newState = {...state, revisions: newRevisions};
			break;

		case updateDataActions.k_clearRevisions:
			newState = {...state, revisions: stdRevisions};

			break;

		case updateDataActions.k_removeAllData:
			newState = stdData;
			break;
		
		default:
			return state;
	}
	return newState;
}


// WEBPACK FOOTER //
// ./js/stateStuff/reducers/updateDataReducers.js